<template>
  <v-card
    class="profile-card elevation-8 mt-2"
    :class="{ hovered: isHovered }"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <!-- Background with gradient overlay -->
    <div class="bg-container">
      <v-img
        :src="profile.bgImage || require('@/assets/background0.png')"
        width="100%"
        :aspect-ratio="$vuetify.breakpoint.smAndDown ? 414 / 180 : 1654 / 455"
        class="bg-image"
      >
        <div class="gradient-overlay"></div>
        <div class="glass-overlay"></div>
      </v-img>

      <!-- Status indicator -->
      <!-- <div class="status-indicator online" v-if="profile.isOnline">
        <div class="pulse-ring"></div>
        <div class="pulse-dot"></div>
      </div> -->
    </div>

    <!-- Main content -->
    <div class="content-wrapper">
      <!-- Avatar with premium styling -->
      <div class="avatar-container" :class="{ floating: isHovered }">
        <div class="avatar-ring"></div>
        <div class="avatar-wrapper" @click="goToProfile">
          <img
            v-if="profile.midThumbnail || profile.image"
            :src="profile.midThumbnail || profile.image"
            :alt="name"
            class="avatar-img"
          />
          <img
            v-else
            :src="placeholderImage"
            alt="Profile_Default"
            class="avatar-img"
          />
          <div class="avatar-overlay">
            <v-icon color="white" size="20">mdi-eye</v-icon>
          </div>
        </div>
      </div>

      <!-- Name and location -->
      <div class="profile-info">
        <h2 class="profile-name" @click="goToProfile" v-if="profile.first_name">
          {{ truncateFullName(profile.first_name + " " + profile.last_name) }}
          <v-icon
            class="verified-badge"
            color="success"
            size="18"
            v-if="profile.verifiedFromVerifiedFirst"
            title="Verified First"
          >
            mdi-check-decagram
          </v-icon>
          <v-icon
            class="verified-badge"
            color="#1DA1F2"
            size="18"
            v-if="profile.email_verified"
          >
            mdi-check-decagram
          </v-icon>
        </h2>
        <div class="location-wrapper">
          <div class="location-info" v-if="profile.address">
            <v-icon class="location-icon">mdi-map-marker</v-icon>
            <span class="location-text">
              <!-- {{ profile.address2 ? profile.address2 + ", " : "" }} -->
              {{ profile.address }}, {{ profile.city }}
            </span>
          </div>
        </div>
      </div>

      <!-- Stats section with modern cards -->
      <!-- <div class="stats-container">
        <div class="stat-card hours-card" @click="goToFollowers">
          <div class="stat-icon-wrapper hours">
            <v-icon class="stat-icon">mdi mdi-account-multiple-plus-outline</v-icon>
          </div>
            <div class="stat-content">
              <div class="stat-number">
                {{ profile.followed_by && profile.followed_by.length ? profile.followed_by.length : 0 }}
              </div>
              <div class="stat-label">
                {{ (profile.followed_by && profile.followed_by.length === 1) ? 'Follower' : 'Followers' }}
              </div>
            </div>
          <div class="stat-hover-effect"></div>
        </div>

        <div class="divider-line"></div>

        <div class="stat-card followers-card" @click="goToFollowings">
          <div class="stat-icon-wrapper followers">
            <v-icon class="stat-icon">mdi-account-group</v-icon>
          </div>
          <div class="stat-content">
            <div class="stat-number">
              {{ profile.followers && profile.followers.length ? profile.followers.length : 0 }}
            </div>
            <div class="stat-label">Following</div>
          </div>
          <div class="stat-hover-effect"></div>
        </div>
        
      </div> -->

<div class="stats-container">
  <!-- ✅ Followers (People who follow me) -->
  <div class="stat-card hours-card" @click="goToFollowers">
    <div class="stat-icon-wrapper hours">
      <v-icon class="stat-icon">mdi-account-multiple-plus-outline</v-icon>
    </div>
    <div class="stat-content">
      <div class="stat-number">
        {{ profile.followers?.length || 0 }}
      </div>
      <div class="stat-label">
        {{ profile.followers?.length === 1 ? 'Follower' : 'Followers' }}
      </div>
    </div>
    <div class="stat-hover-effect"></div>
  </div>

  <div class="divider-line"></div>

  <!-- ✅ Following (People I follow) -->
  <div class="stat-card followers-card" @click="goToFollowings">
    <div class="stat-icon-wrapper followers">
      <v-icon class="stat-icon">mdi-account-group</v-icon>
    </div>
    <div class="stat-content">
      <div class="stat-number">
        {{ profile.followed_by?.length || 0 }}
      </div>
      <div class="stat-label">
       {{ profile.followed_by?.length === 1 ? 'Following' : 'Following' }}
      </div>
    </div>
    <div class="stat-hover-effect"></div>
  </div>
</div>

      <!-- Action buttons -->
      <div class="action-buttons">
        <v-btn
          class="action-btn primary-btn"
          elevation="0"
          @click="goToWorkHours"
        >
          <v-icon left>mdi-clock-time-four</v-icon>
          Hours
        </v-btn>
        <!-- <v-btn 
          class="action-btn secondary-btn"
          elevation="0"
          outlined
          @click="goToSetting"
        >
          <v-icon left>mdi-cog</v-icon>
          Settings
        </v-btn> -->
      </div>
    </div>

    <!-- Floating completion indicator -->
    <!-- <div class="completion-indicator" v-if="getCompletionPercentage < 100">
      <div class="completion-ring">
        <svg class="progress-ring" width="40" height="40">
          <circle
            class="progress-ring-bg"
            stroke="#e6e6e6"
            stroke-width="3"
            fill="transparent"
            r="16"
            cx="20"
            cy="20"
          />
          <circle
            class="progress-ring-progress"
            :stroke="getCompletionColor"
            stroke-width="3"
            fill="transparent"
            r="16"
            cx="20"
            cy="20"
            :stroke-dasharray="circumference"
            :stroke-dashoffset="progressOffset"
          />
        </svg>
        <div class="completion-percentage">{{ getCompletionPercentage }}%</div>
      </div>
    </div> -->
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
// import VolunteerAvatar from "./VolunteerAvatar";

export default {
  components: {},
  props: {
    profile: Object,
    onClicked: Function,
  },
  data() {
    return {
      placeholderImage: require("@/assets/default.jpg"),
      profileColour: {},
      name: "",
      avatarBorderColor: "none",
      avatarBorderStyle: "none",
      isHovered: false,
      circumference: 2 * Math.PI * 16,
    };
  },
  computed: {
    getCompletionPercentage() {
      if (!this.profile._id) return 0;
      const fields = [
        "image",
        "about_me",
        "phone_verified",
        "email_verified",
        "interests",
        "causes",
        "availabilities",
        "phone",
        "address",
        "city",
        "state",
        "zip",
      ];

      let completed = 0;
      fields.forEach((field) => {
        if (field === "phone_verified" || field === "email_verified") {
          if (this.profile[field]) completed++;
        } else if (
          field === "interests" ||
          field === "causes" ||
          field === "availabilities"
        ) {
          if (this.profile[field] && this.profile[field].length > 0)
            completed++;
        } else {
          if (this.profile[field]) completed++;
        }
      });

      return Math.round((completed / fields.length) * 100);
    },
    getCompletionColor() {
      const percentage = this.getCompletionPercentage;
      if (percentage >= 80) return "#4CAF50";
      if (percentage >= 60) return "#FF9800";
      return "#F44336";
    },
    progressOffset() {
      const percentage = this.getCompletionPercentage;
      return this.circumference - (percentage / 100) * this.circumference;
    },
    getCompletedInfo() {
      // Keep original logic for backwards compatibility
      if (!this.profile._id) return "";
      var str = "";
      if (!this.profile.image) str += "Image";
      if (!this.profile.about_me)
        str ? (str += ", About Me") : (str = "About Me");
      if (!this.profile.phone_verified)
        str ? (str += ", Phone not verified") : (str = "Phone not verified");
      if (!this.profile.email_verified)
        str ? (str += ", Email not verified") : (str = "Email not verified");
      if (this.profile.interests && this.profile.interests.length == 0) {
        str ? (str += ", Interests not set") : (str = "Interests not set");
      }
      if (this.profile.causes && this.profile.causes.length == 0) {
        str ? (str += ", Causes not set") : (str = "Causes not set");
      }
      if (
        this.profile.availabilities &&
        this.profile.availabilities.length == 0
      ) {
        str
          ? (str += ", Availabilities not set")
          : (str = "Availabilities not set");
      }
      if (!this.profile.phone) str ? (str += ", Phone") : (str = "Phone");
      if (!this.profile.address) str ? (str += ", Address") : (str = "Address");
      if (!this.profile.city) str ? (str += ", City") : (str = "City");
      if (!this.profile.state) str ? (str += ", State") : (str = "State");
      if (!this.profile.zip) str ? (str += ", Zip") : (str = "Zip");
      return str;
    },
  },
  methods: {
    ...mapActions({
      volunteerProfile: "volunteer/volunteerProfile",
    }),
    goToProfile() {
      this.$router.push({
        name: "volunteer-profile-details",
        params: { id: this.profile._id },
      });
    },
    goToSetting() {
      if (!this.profile.email_verified || !this.profile.phone_verified) {
        this.$router.push({ name: "settings" });
      } else {
        this.$router.push({
          name: "volunteer-profile-about",
          params: { id: this.profile._id },
        });
      }
    },
    truncateFullName(first, last, length = 15) {
      const fullName = `${first || ""} ${last || ""}`.trim();
      return fullName.length > length
        ? fullName.slice(0, length) + "..."
        : fullName;
    },
    goToWorkHours() {
      this.$router.push({ name: "volunteer-hours" });
    },
    followers() {
      this.$router.push({ name: "volunteers" });
    },
    goToFollowings() {
      this.$router.push({
        name: "volunteers",
        query: { tab: "following" },
      });
    },
    goToFollowers() {
      this.$router.push({
        name: "volunteers",
        query: { tab: "followers" },
      });
    },
    loadColours() {
      this.volunteerProfile()
        .then((res) => {
          this.profileColour = res;
          this.avatarBorderColor = this.profileColour.avatarColour || "none";
          this.avatarBorderStyle = this.profileColour.avatarColour
            ? "solid"
            : "none";
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.loadColours();
  },
};
</script>

<style scoped>
.profile-card {
  position: relative;
  border-radius: 24px !important;
  overflow: hidden;
  background: linear-gradient(145deg, #ffffff, #f8f9fa);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 400px;
  margin: 0 auto;
}

.profile-card.hovered {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15) !important;
}

.bg-container {
  position: relative;
  /* height: 180px; */
  overflow: hidden;
}

.bg-image {
  border-radius: 24px 24px 0 0;
  transition: transform 0.6s ease;
}

.profile-card.hovered .bg-image {
  transform: scale(1.1);
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(8, 68, 104, 0.3) 0%,
    rgba(10, 91, 138, 0.3) 50%,
    rgba(10, 91, 138, 0.3) 100%
  );
}

.glass-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(1px);
}

.status-indicator {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 3;
}

.status-indicator.online {
  width: 12px;
  height: 12px;
  position: relative;
}

.pulse-ring {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid #4caf50;
  border-radius: 50%;
  animation: pulse-ring 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
  top: -4px;
  left: -4px;
}

.pulse-dot {
  width: 12px;
  height: 12px;
  background: #4caf50;
  border-radius: 50%;
  border: 2px solid white;
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.33);
    opacity: 1;
  }
  80%,
  100% {
    transform: scale(1.33);
    opacity: 0;
  }
}

.content-wrapper {
  padding: 0 24px 24px;
  position: relative;
}

.avatar-container {
  display: flex;
  justify-content: center;
  margin-top: -46px;
  margin-bottom: 7px;
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease;
}

.avatar-container.floating {
  transform: translateY(-4px);
}

/* .avatar-ring {
  position: absolute;
  width: 104px;
  height: 104px;
  border: 3px solid;
  border-image: linear-gradient(45deg, #667eea, #764ba2) 1;
  border-radius: 50%;
  top: -4px;
  left: 50%;
  transform: translateX(-50%);
  animation: rotate 8s linear infinite;
} */

@keyframes rotate {
  from {
    transform: translateX(-50%) rotate(0deg);
  }
  to {
    transform: translateX(-50%) rotate(360deg);
  }
}

.avatar-wrapper {
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(145deg, #f0f0f0, #cacaca);
  padding: 4px;
}

.avatar-wrapper:hover {
  transform: scale(1.05);
}

.avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.avatar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
}

.avatar-wrapper:hover .avatar-overlay {
  opacity: 1;
}

.profile-info {
  text-align: center;
  margin-bottom: 10px;
}

.profile-name {
  font-size: 24px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 2px 0;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.profile-name:hover {
  color: #0a5b8a;
  transform: translateY(-1px);
}

.verified-badge {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.location-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #718096;
  font-size: 14px;
}

.location-icon {
  color: #e52020 !important;
  font-size: 16px !important;
}

.stats-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  gap: 16px;
}

.stat-card {
  /* flex: 1; */
  background: linear-gradient(145deg, #ffffff, #f7fafc);
  border-radius: 16px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  border-bottom: 4px solid #0a5b8a;
}

.stat-hover-effect {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  transition: left 0.5s ease;
}

.stat-card:hover .stat-hover-effect {
  left: 100%;
}

.stat-icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  transition: transform 0.3s ease;
}

.stat-icon-wrapper.hours {
  background: linear-gradient(135deg, #0a5b8a, #1da1f2);
}

.stat-icon-wrapper.followers {
  background: linear-gradient(135deg, #0a5b8a, #4caf50);
}

.stat-card:hover .stat-icon-wrapper {
  transform: scale(1.1) rotate(5deg);
}

.stat-icon {
  color: white !important;
  font-size: 20px !important;
}

.stat-content {
  text-align: center;
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: #718096;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.divider-line {
  width: 1px;
  height: 40px;
  background: linear-gradient(to bottom, #00000063, #006dff, transparent);
  margin: 0 8px;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.action-btn {
  flex: 1;
  height: 48px !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  transition: all 0.3s ease !important;
}

.primary-btn {
  background: linear-gradient(135deg, #084468, #0a5b8a) !important;
  color: white !important;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.4) !important;
}

.secondary-btn {
  border: 2px solid #0a5b8a !important;
  color: #0a5b8a !important;
}

.secondary-btn:hover {
  background: #0a5b8a !important;
  color: white !important;
  transform: translateY(-2px);
}

.completion-indicator {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 3;
}

.completion-ring {
  position: relative;
  width: 40px;
  height: 40px;
}

.progress-ring {
  transform: rotate(-90deg);
}

.progress-ring-progress {
  transition: stroke-dashoffset 0.5s ease-in-out;
  stroke-linecap: round;
}

.completion-percentage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  font-weight: 700;
  color: #1a202c;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .profile-card {
    margin: 16px;
    border-radius: 20px !important;
  }

  .content-wrapper {
    padding: 0 20px 20px;
  }

  .profile-name {
    font-size: 20px;
  }

  .stat-card {
    padding: 12px;
  }

  .stat-number {
    font-size: 20px;
  }

  .action-buttons {
    flex-direction: column;
  }
}

.location-wrapper {
  display: inline-flex;
  align-items: center;
  background: rgba(236, 240, 241, 0.7);
  padding: 6px 12px;
  border-radius: 20px;
  transition: all 0.3s ease;
}
</style>